import { Layout } from "../components/Layout";
import { Hero } from "../components/Hero";
import { Contact } from "../components/Contact";
import { Seo } from "../components/Seo";
import {
  TrustedBy, AboutIntro, StrategicFoundation, Numbers, ServicesShowcase, NorbitShowcase, IndustriesGrid,
  PortfolioGrid, CaseStudiesPreview, ProcessSteps, TechMarquee, WhyChoose,
  Testimonials, BlogsPreview, FAQ,
} from "../components/Sections";
import { FAQS, TAGLINE, COMPANY_CORE_THOUGHT, LEGAL_ENTITY, SOCIAL_LINKS } from "../data";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://neuravolt.in/#organization",
    "name": "NeuraVolt Technology",
    "legalName": LEGAL_ENTITY,
    "url": "https://neuravolt.in",
    "slogan": TAGLINE,
    "logo": "https://neuravolt.in/assets/logo.png",
    "description": COMPANY_CORE_THOUGHT,
    "foundingDate": "2024",
    "email": "info@neuravolt.in",
    "telephone": "+919202243725",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "E Block, 511, Amity Innovation Center",
      "addressLocality": "Gwalior",
      "addressRegion": "Madhya Pradesh",
      "postalCode": "474020",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 26.2183,
      "longitude": 78.1828
    },
    "sameAs": [
      SOCIAL_LINKS.linkedin,
      SOCIAL_LINKS.linkedin_profile,
      SOCIAL_LINKS.instagram,
      SOCIAL_LINKS.github,
      SOCIAL_LINKS.google_maps,
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "sales",
      "telephone": "+919202243725",
      "email": "info@neuravolt.in",
      "url": "https://neuravolt.in/contact",
      "availableLanguage": ["English", "Hindi"]
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://neuravolt.in/#localbusiness",
    "name": "NeuraVolt Technology",
    "legalName": LEGAL_ENTITY,
    "url": "https://neuravolt.in",
    "logo": "https://neuravolt.in/assets/logo.png",
    "description": "AI-first software engineering company based at Amity Innovation Center, Gwalior. Specializing in AI development, custom software development, cloud infrastructure, and sovereign enterprise platforms.",
    "telephone": "+919202243725",
    "email": "info@neuravolt.in",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "E Block, 511, Amity Innovation Center",
      "addressLocality": "Gwalior",
      "addressRegion": "Madhya Pradesh",
      "postalCode": "474020",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 26.2183,
      "longitude": 78.1828
    },
    "hasMap": "https://www.google.com/maps/place/Neuravolt+Technology/data=!4m2!3m1!1s0x0:0x47b13dd0dbd4c8f5",
    "priceRange": "$$",
    "areaServed": [
      { "@type": "City", "name": "Gwalior" },
      { "@type": "Country", "name": "India" },
      { "@type": "Country", "name": "United States" },
      { "@type": "Country", "name": "United Arab Emirates" }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Neuravolt",
    "url": "https://neuravolt.in"
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQS.map(f => ({
      "@type": "Question",
      "name": f.q,
      "acceptedAnswer": { "@type": "Answer", "text": f.a }
    }))
  }
];

export default function Home() {
  return (
    <Layout>
      <Seo
        title="NeuraVolt | AI-First Software Engineering Company & Enterprise Operating Systems"
        description="NeuraVolt brings fragmented technology together into one connected ecosystem. AI development, custom software engineering, cloud infrastructure, and sovereign enterprise operating systems from Gwalior to global enterprises."
        keywords="NeuraVolt, NeuraVolt Technology, AI-first software engineering company, custom software development company, software company in Gwalior, IT company in Gwalior, sovereign enterprise operating system, cloud infrastructure, nORBIT, VOLTNOVATE SOLUTIONS LLP"
        path="/"
        jsonLd={jsonLd}
      />
      {/* 1 & 2. Hero Fold */}
      <Hero />
      {/* 3. Trusted by Businesses Across the Globe */}
      <TrustedBy />
      {/* 4. Who we are? */}
      <AboutIntro />
      {/* 4.5 The NeuraVolt Foundation: Purpose, Vision, Mission & Core Thought */}
      <StrategicFoundation />
      <Numbers />
      {/* 5. What we do? Services & Products Engineered for Scale */}
      <ServicesShowcase />
      {/* 6. Who we've worked for? */}
      <IndustriesGrid />
      {/* 7. What We've Built */}
      <PortfolioGrid isHome={true} />
      {/* 8. How do We Operate? */}
      <ProcessSteps />
      {/* 9. What Fuels Our Services (Our Stack Section) */}
      <TechMarquee />
      {/* 10. Real Work, Real Stories (Case Studies) */}
      <CaseStudiesPreview />
      {/* 11. Why Choose Us? */}
      <WhyChoose />
      {/* 12. What Do Our Clients Say? */}
      <Testimonials />
      {/* 13. Blog preview */}
      <BlogsPreview />
      {/* 14. FAQ */}
      <FAQ />
      {/* 15. Contact (single callout, duplicate CTA removed) */}
      <Contact />
    </Layout>
  );
}
